export default function filterNonNulls<T>(
  array: ReadonlyArray<T | null | undefined> | undefined
): T[] {
  if (array === undefined) {
    return [];
  }
  return array.filter((item) => item !== null && item !== undefined) as T[];
}
